var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdidasLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 24,
    viewBox: "0 0 41 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3032 12.3127L26.9002 0L23.8509 1.83473L19.0078 4.74569L23.8509 12.8098L30.2442 23.4671H34.3032H40.9989L34.3032 12.3127Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8524 19.0803L17.4027 8.34863L9.76137 12.9483L9.5 13.102L9.76137 13.5351L15.7294 23.4672H23.8524H26.4764L23.8524 19.0803Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76045 19.7974L7.90009 16.707L0 21.4527L1.20692 23.4668H9.76045H11.9616L9.76045 19.7974Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdidasLogo);
export default __webpack_public_path__ + "static/media/adidas-logo.404102099fc687246c37ce84695b2ca0.svg";
export { ForwardRef as ReactComponent };